<template>
    <div style="background-color:rgb(204 204 204 / 0.25);;padding:20px">
         
        <div style="display:flex;justify-content: center;">
            <img class="img_size" src="../../assets/img/group_2.png"/>
        </div>
       <div style="text-align:center;padding-top:20.7px;font-size:20px">
           <h3>Product Details</h3>
       </div>
       <div style="padding-top:21px;height: 100%;padding: 46px;margin-bottom:30px;">
         <div style="text-align:center;">
              <p style="font-size:20px;line-height:32px">Please tell us about the products you sell at your store</p>
         </div>
         <div>
            <div>
                <a-form-model
                    ref="addNewRequestInventoryForm"
                    :model="newRequestInventoryform"
                   
                >
                <a-row 
                    v-for="(request, index) in newRequestInventoryform.request"
                    :key="request.key"
                    type="flex" 
                    justify="space-around"
                    >
                    <a-col :span="8">
                        <a-form-model-item 
                            label="Product Name" 
                            :prop="'request.' + index + '.productId'"
                            :rules="{
                                required: true,
                                message: 'Please enter your product name',
                                trigger: 'blur',
                            }"
                            >
                            <a-select
                                show-search
                                placeholder="Choose your product"
                                option-filter-prop="children"
                                v-model="request.productId"
                                :filter-option="filterOption"
                                @change="onCategoryChange(request)"
                            >
                                <a-select-option v-for="product in products" :key="product.id" v-bind:value="product.id">
                                    {{product.brandName}}
                                </a-select-option>
                            </a-select>
                            
                        </a-form-model-item>
                    </a-col>
                    
                    <a-col :span="8">
                        <a-form-model-item 
                            label="Quantity" 
                            :prop="'request.' + index + '.quantity'"
                            :rules="{
                                required: true,
                                message: 'Please enter your quantity',
                                trigger: 'blur',
                            }"
                            >
                                <a-input-number 
                                    :min="1" 
                                    class="rightSideinputText" 
                                    type="number"  
                                    v-model="request.quantity"
                                    @change="onQuantityChange(request)"
                                />
                        </a-form-model-item>
                    </a-col>
                    
                    <a-col :span="2">
                        <div style="margin-top: 46px;">
                           <a-icon
                                v-if="newRequestInventoryform.request.length > 1"
                                class="dynamic-delete-button"
                                type="minus-circle-o"
                                :disabled="newRequestInventoryform.request.length === 1"
                                @click="removeDomain(request)"
                            />
                        </div>
                    </a-col>
                    
                </a-row>
                <a-form-model-item >
                    <a-button  style="margin:0 auto;float: right; background:#418a49; color:#fff;" @click="addDomain">
                        <a-icon type="plus" /> Add Product
                    </a-button>
                </a-form-model-item>
                </a-form-model>
            </div>
            <div style="display:flex;justify-content: center;padding-bottom: 10px;padding-top:20px">
                    <a-spin class="spinner" :spinning="loading" />
            </div>
            <div style="display:flex;justify-content: center;padding-top: 40px;">
                <a-button @click="handleRequestInventory()" style="background: #418a49;height:45px;color:#fff;width:256px;">
                        Save & Submit
                </a-button>
            </div>  
         </div>
       </div>

    </div>
</template>

<script>
import { mapActions } from 'vuex';

const columns = [
  {
    key:'productName',
    title: 'Product Name',
    width: 200,
    dataIndex: 'productName',
  },
  {
    key:'price',
    title: 'Price',
    dataIndex: 'price',
     width: 200,
    scopedSlots: { customRender: 'price' },
  },
  {
    title: 'Action',
    key: 'action',
     width: 200,
    scopedSlots: { customRender: 'action' },
  },
];

    export default {
        name: 'ProductInfo',
        data() {
            return {
                products: [],
                columns,
                searchText:'',
                loading: false,
                confirmLoading: false,
                form: {
                    email: '',
                    password: ''
                },
                // rules: {
                //     productId: [
                //         { required: true, message: 'Please choose your product' , trigger: 'change'},
                        
                //     ],
                //     quantity: [
                //         { required: true, message: 'Please enter your quantity', trigger: 'change' },
                //         {   
                //                 pattern: new RegExp(/^[1-9]\d*$/), 
                //                 message: 'Please enter valid number', 
                //                 trigger: 'blur'
                //         },
                //     ]
                // },
                newRequestInventoryform:{
                    request:[
                        {
                            productId:'',
                            quantity: '',
                            key: Date.now()
                        }
                    ]
                }
            };
        },
        methods:{
            ...mapActions(['getSystemProducts','addInventoryRequest','getAgentProfile','addProductDetails']),
            
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            handleRequestInventory(){
                this.loading = true;
                // console.log("newRequestInventoryform | ", this.newRequestInventoryform.request)
                let items = {}
                this.newRequestInventoryform.request.forEach(row => {
                    items[row.productId] = row.quantity
                })
                // console.log("items | ", items)   
                this.addProductDetails(items).then(data => {
                    // console.log("data | ", data)
                    if(data.status === 200){
                        this.getAgentProfile().then(result => {
                            this.loading = false;
                            // console.log("result | ", result)
                            if(result.status === 200){
                                // this.addOnboardVisible = true
                                // this.setStepCount(2)
                                this.showSuccessAlert("Yaay, Onboarding Completed Successfully");
                                this.$router.push('/overview').catch(()=>{});
                                // this.$refs.AddNewStockform.resetFields();
                            }else if(result.status === 400){
                                this.loading = false;
                                this.showErrorAlert("Something went wrong, try again later")
                            }else{
                                this.loading = false;
                                this.showErrorAlert(result.data.messages)
                            }  
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        }) 
                    }else if(data.status === 400){
                        this.loading = false;
                        this.showErrorAlert("Something went wrong, try again later")
                    }else{
                        this.loading = false;
                        this.showErrorAlert(data.data.messages)
                    }  
                },
                error =>{
                    this.loading = false
                    this.showErrorAlert(JSON.stringify(error))
                })        
            },
            addDomain() {
                this.newRequestInventoryform.request.push({
                    productId: '',
                    quantity: '',
                    key: Date.now()
                });
            },
            removeDomain(item) {
                let index = this.newRequestInventoryform.request.indexOf(item);
                if (index !== -1) {
                    this.newRequestInventoryform.request.splice(index, 1);
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            onCategoryChange(item){
                // console.log("item | ", item)
                
                this.products.forEach(product => {
                    if(product.id === item.productId){
                        // console.log("product | ", product)
                        item['price'] = parseFloat(product.sellingPrice).toFixed(2)
                    }
                })
                this.onQuantityChange(item)
                this.newRequestInventoryform.request[item]
                // console.log("request | ", this.newRequestInventoryform.request)
                
            },
            onQuantityChange(item){

                if(item['quantity']){
                    this.products.forEach(product => {
                        if(product.id === item.productId){
                            item['total'] = parseFloat(parseFloat(item['price']) * parseFloat(item['quantity'])).toFixed(2)
                        }
                    })
                }else{
                    this.products.forEach(product => {
                        if(product.id === item.productId){
                            item['total'] = 0.00
                        }
                    })
                }
                this.newRequestInventoryform.request[item]
            }
        },
        created() {
            this.getSystemProducts().then(response => {
                
                this.products = response.data.data
            },
            error => {
                console.log("error | ", error)
            })
        },
        
    }
</script>

<style scoped>
.actions{
    display: flex;
    justify-content: space-between;
}
.img_size{
    max-width: 56px;
    max-height: 55px;
}

.rightSideinputText{
    width: 100%;
    border-radius: 5px;
}

.totalAmount{
    text-align:center;
    height: 93px;
    background: #eaec84;
    margin-left: 256px;
    font-size: 20px;
    margin-right: 256px;
    padding-top: 18px;
    margin-top: 25px;
    color:#266423;
}

.dropdownItem >>> .ant-select-selection__placeholder, 
.ant-select-search__field__placeholder {
    line-height: 29px;
}
.dropdownItem >>> .ant-select-selection--single {
    position: relative;
    height: 45px;
    cursor: pointer;
}
.dropdownItem >>> .ant-select-selection-selected-value {
    line-height: 46px;
}

.requestInventoryTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.requestInventoryTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

button:hover,
button:active{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

.requestInventoryTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.requestInventoryTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}
.spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}
</style>

